// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__dyq2Z"};